import React from "react";
import { renderToStaticMarkup } from "react-dom/server";
import LetterDocument from "@/components/LetterDocument";

// Prints one letter on its own (in a hidden iframe) so the rest of the app never ends up on the page.
// In the print dialog choose "Save as PDF" to download it.
export function printLetter(letter, profile) {
  const markup = renderToStaticMarkup(<LetterDocument letter={letter} profile={profile} mode="print" />);
  const title = (letter.title || "Letter").replace(/[<>&"]/g, "");

  const iframe = document.createElement("iframe");
  iframe.setAttribute("aria-hidden", "true");
  iframe.style.cssText = "position:fixed;right:0;bottom:0;width:0;height:0;border:0;visibility:hidden;";
  document.body.appendChild(iframe);

  const doc = iframe.contentWindow.document;
  doc.open();
  doc.write(`<!DOCTYPE html><html><head><meta charset="utf-8"><title>${title}</title>
<base href="${window.location.origin}/">
<link rel="preconnect" href="https://fonts.googleapis.com">
<link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap" rel="stylesheet">
<style>
@page { size: A4; margin: 0; }
html, body { margin: 0; padding: 0; background: #fff; }
body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
</style></head><body>${markup}</body></html>`);
  doc.close();

  let done = false;
  const cleanup = () => { setTimeout(() => { try { document.body.removeChild(iframe); } catch (e) { /* already removed */ } }, 1500); };
  const go = () => {
    if (done) return;
    done = true;
    try {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    } finally {
      cleanup();
    }
  };

  // Wait for fonts and images (logo / signature) so the print preview is complete.
  const waitImages = () => Promise.all(
    Array.from(doc.images || []).map((img) => (img.complete ? Promise.resolve() : new Promise((res) => { img.onload = res; img.onerror = res; })))
  );
  const fontsReady = doc.fonts && doc.fonts.ready ? doc.fonts.ready : Promise.resolve();
  Promise.race([
    Promise.all([fontsReady, waitImages()]),
    new Promise((res) => setTimeout(res, 4000)),
  ]).then(() => setTimeout(go, 150));
}
